import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import styled from 'styled-components';
import { useLocation } from 'react-router';
import { BundleCategoriesState, BundleCategoryResponse } from './bundleCategories';
import { SidebarContainer } from '../../../shared/common/SidebarContainer';
import { useTranslation } from 'react-i18next';

const StyledSidebarContainer = styled(SidebarContainer)`
    a:not(.active):not(:hover) {
        color: #000000;
    }
`;

type Props = {
    readonly categories?: string;
    readonly releaseYear?: string;
    readonly bundleCategories: BundleCategoryResponse;
};

export const BundleListCategories = (props: Props) => {
    const { t } = useTranslation();
    const location = useLocation();
    function renderCategories(categories: BundleCategoriesState['categories'], clazz?: string) {
        const cats: ReactNode[] = [];
        if (categories && categories.buckets) {
            cats.push(
                categories?.buckets.map((category, i) => {
                    clazz = classNames({
                        active: props.categories === category.key
                    });
                    return (
                        <div className="fe" key={i}>
                            <div className="filter-label">
                                <Link to={buildUrlPath('categories', category.key)} className={clazz}>
                                    {category.key} <span className="count">({category.docCount})</span>
                                </Link>
                            </div>
                        </div>
                    );
                })
            );
        }
        return cats;
    }

    function renderReleaseYear(releaseYear?: BundleCategoriesState['releaseYear']): ReactNode[] | null {
        let years: ReactNode[] | null = null;
        if (releaseYear && releaseYear.buckets) {
            years = [
                <div className="fe" style={{ marginTop: '0px' }} key="releases">
                    <div className="filter-label">{t('shop.catalogue.productGroup.newReleases')}</div>
                </div>
            ];
            years.push(
                releaseYear.buckets.map((year, i) => {
                    const clazz = classNames({
                        active: props.releaseYear === year.key
                    });
                    return (
                        <div className="fe" key={i}>
                            <div className="filter-label" style={{ paddingLeft: '15px' }}>
                                <Link to={buildUrlPath('releaseYear', year.key)} className={clazz}>
                                    {year.key} <span className="count">({year.docCount})</span>
                                </Link>
                            </div>
                        </div>
                    );
                })
            );
        }
        return years;
    }

    function buildUrlPath(param?: string, value?: string): string {
        let path = location.pathname;
        if (param) {
            path += `?${param}=${value}`;
        }
        return path;
    }

    const { aggregations } = props?.bundleCategories ?? [];

    const totalCount = props?.bundleCategories.totalHits ?? 0;
    const categoryClasses = classNames({
        active: !props.categories && !props.releaseYear
    });
    const categories = renderCategories(aggregations?.categories, categoryClasses);
    const releaseYear = renderReleaseYear(aggregations?.releaseYear);

    return (
        <StyledSidebarContainer>
            <div className="fe">
                <div className="filter-label">
                    <Link to={buildUrlPath()} className={categoryClasses}>
                        {t('allContentSelections')} <span className="count">({totalCount})</span>
                    </Link>
                </div>
            </div>
            <div className="filter-items">{releaseYear}</div>
            <div className="filter-items">{categories}</div>
        </StyledSidebarContainer>
    );
};
